import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import {
  EventEmitter,
  ViewChild,
  Component,
  OnInit,
  Output,
  Input,
} from '@angular/core';
import { SubSink } from 'subsink';
import { AppNotification, Order } from 'src/app/shared';
import { NavigationEnd, Router } from '@angular/router';
import { map, Observable, of, shareReplay } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AuthService, UserRoles, UserSchema, UserService, newUserModel } from 'src/app/core';
import { DropdownComponent } from 'src/app/shared/components/dropdown/dropdown.component';
import { LandingAuthBoxService } from 'src/app/feature/landing';
import { ComponentBusService } from 'src/app/feature/landing/services/component-bus.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

  @Input('isAuthenticated') isAuthenticated: boolean = false;
  @Input('orders') orders!: Order[];

  @Output() openSidenav = new EventEmitter();
  @ViewChild('userFloatingMenu') userFloatingDropdown!: DropdownComponent;
  @ViewChild('cartDropdown') userShoppingCartDropdown!: DropdownComponent;

  // --------------------------Public Properties|
  public notifications: AppNotification[] = [];
  public user: UserSchema | undefined;
  currentUser: newUserModel;
  public loading: boolean = true;
  public userIsVerified!: boolean;
  public userRoles = UserRoles;
  public isHandset = false;
  public ordersCount = 0;
  isLoginModalOpen = false;
  adminRoutes = false;
  public overlayIsOpen = false;
  public bottomSheetOverlay!: MatBottomSheetRef;
  // --------------------------Private Properties|

  private subsink = new SubSink();

  showMenu: boolean = false;

  public isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );
  

  get notifications$() {
    return of(this.notifications);
  }

  get notSeenNotificationsLen$(): Observable<number | undefined> {
    return this.notifications$.pipe(
      map((value: AppNotification[], index: any) => {
        const len = value.filter(
          (notification: AppNotification) => !notification.seen
        ).length;

        return len > 0 ? len : undefined;
      })
    );
  }

  mobileMenuTitles = {
    print: 'print',
    thesis: 'thesis',
    support: 'support',
  };

  selectedMenuTitle: any = null;

  // Constructors ----------------------------------------------------->

  ngOnInit(): void {
    this.loading = true;

    this.subsink.sink = this.authService.userProfile?.subscribe(
      {
        next: (userProfile) => {
          this.user = userProfile;
          this.loading = false;
          if(userProfile?.id) this.isAuthenticated = true;
        },
        error: (error) => {
          this.loading = false;
          this.user = undefined;
          this.isAuthenticated = false;
        }
      }
    );

    this.subsink.sink = this.isHandset$.subscribe((result) => {
      this.isHandset = result;
    });

    this.subsink.sink = this.userService.notificationsSubject$.subscribe(
      (notifications) => {
        this.notifications = notifications;
      }
    );

    this.busService.events$.subscribe({
      next: ({ context }) => {
        switch (context) {
          case 'order-add':
        }
      },
    });
  }


  constructor(
    private breakpointObserver: BreakpointObserver,
    private authBox: LandingAuthBoxService,
    private busService: ComponentBusService,
    private userService: UserService,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private router: Router,
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.url.startsWith('/admin')) this.adminRoutes = true;
        else this.adminRoutes = false;
      }
    })
    this.refresh();

    // this.subsink.sink = this.userService.status$.subscribe((statusObject) => {
    //   if (statusObject.status === 'activate') {
    //     this.checkUserActivationStatus();
    //   } else if (statusObject.status === 'update') {
    //     this.setUser(statusObject.payload as UserSchema);
    //   }
    // });

    this.subsink.sink = this.userService.currentUser.subscribe(user => {
      this.currentUser = user;
    })

    this.subsink.sink = this.authService.authStatus.subscribe((status) => {
      if (status?.isOk) {
        this.user = status?.data as UserSchema;
        this.isAuthenticated = true;
      }
    });

    // this.subsink.sink = this.authService.authStatus.subscribe((statusObject) => {
      // if (statusObject?.type === 'activation') {
        // this.checkUserActivationStatus();
      // }
    // });
    this.subsink.sink = this.userService.userOrders.subscribe(
      (orders) => {
        this.orders = orders;
        this.ordersCount = orders.length;
      },
      (error) => {
        this.orders = [];
        this.ordersCount = 0;
      }
    );
  
    // router.events.subscribe(() => {
    //   this.refresh();
    // });
  }



  // Public Methods --------------------------------------------------->
  public toggleUserMenu() {
    this.isLoginModalOpen = !this.isLoginModalOpen;
    this.isHandset$.subscribe((result) => {
      if (result) {
        if (this.isAuthenticated) {
          return this.toggleUserMenuAsSidenav();
        }

        return this.authService.openAuthBox();
      } else {
        if (this.isAuthenticated) {
          return this.toggleUserMenuAsMenu();
        }

        return this.authService.openAuthBox();
      }
    });
  }

  public refresh() {
    this.getAndSetUser();
    // this.checkUserActivationStatus();
  }

  public openAuthBox() {
    this.authBox.open('login');
  }

  // public checkUserActivationStatus() {
    // this.userService.().then((activationResult) => {
    //   this.userIsVerified = activationResult;
    // });
    // this.userIsVerified =
    //   this.currentUser.verified === true ? true : false;
  // }

  public setUser(user: UserSchema) {
    this.user = user;
    this.loading = false;
  }

  public getAndSetUser() {
    this.authService.getUserProfile();
      // .then((user) => {
      //   this.user = user;
      //   this.loading = false;
      // })
      // .catch((e) => {
      //   this.loading = false;
      // });
    // this.user = this.authService.userProfileObject;
  }

  closeNavBar() {
    this.showMenu = false;
    this.selectedMenuTitle = null;
  }

  public logoutUser() {
    this.subsink.sink = this.userService.logoutUser().subscribe(() => {
      this.snackBar.open('با موفقیت خارج شدید', '', { duration: 1000 });
      this.closeNavBar();
    });
  }

  scroll() {
    let el = document.getElementById('serviceTitleWrapper');
    setTimeout(() => {
      el?.scrollIntoView({behavior: 'smooth'});
    }, 10);
  }

  // ------------------------------------------Private methods

  public toggleUserMenuAsSidenav() {
    this.openSidenav.emit();
  }

  public toggleUserMenuAsMenu() {
    this.userFloatingDropdown.toggle();
  }

  ngOnDestroy() {
  }
}
